<template>
  <div>
    <p>修改权限配置</p>
    <el-tree ref="tree" :data="authorityData" :default-checked-keys="checkArray" :props="defaultProps" node-key="menuId"
             show-checkbox></el-tree>
    <div class="footerButton">
      <Button type="default" @click="handleBack('add')">返回</Button>
      <Button :loading="authorityLoading" style="margin-left: 10px" type="primary" @click="handleCommit()">
        <span v-if="!authorityLoading">提交</span>
        <span v-else>提交中</span>
      </Button>
    </div>
  </div>
</template>

<script>
import {roleMenuEdit, roleMenuList} from '@/api/authority'

export default {
  name: 'roleAuthority',
  data() {
    return {
      roleId: '',
      authorityLoading: false,
      authorityData: [], // 权限配置数据
      checkArray: [], // 默认勾选的节点的 key 的数组
      defaultProps: {children: 'children', label: 'title'} // 权限配置树状图
    }
  },
  mounted() {
    this.roleId = this.$route.query.roleId
    this.checkArray = []
    roleMenuList(this.roleId).then((res) => {
      this.authorityData = res.data.data
      let getArray = []
      getTableTree(this.authorityData)

      function getTableTree(val) {
        for (const element of val) {
          const son = element
          if (son.children.length) {
            getTableTree(son.children)
          } else if (!son.children.length) {
            if (son.isSelect) {
              getArray.push(son.menuId)
            }
          }
        }
      }

      this.checkArray = getArray
    })
  },
  methods: {
    // 返回
    handleBack() {
      this.$router.push(
        {
          path: '/authority/role',
          query: {
            current: this.$route.query.current,
            size: this.$route.query.size,
            roleName: this.$route.query.roleName
          }
        }
      )
    },
    // 提交
    handleCommit() {
      let menuIds = [
        ...this.$refs.tree.getCheckedKeys(),
        ...this.$refs.tree.getHalfCheckedKeys()
      ]
      this.authorityLoading = true
      let params = 'menuIds=' + menuIds + '&roleId=' + this.roleId
      roleMenuEdit(params).then((response) => {
        if (response.data.success === false) {
          this.$Message.error(response.data.msg)
          this.authorityLoading = false
        } else {
          this.$Message.success(response.data.msg)
          this.authorityLoading = false
          this.$router.push({name: 'role'})
        }
      }).catch(() => {
        this.authorityLoading = false
      })
    }
  }
}
</script>
